<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">角色权限管理</span>
			<Button color="green" size="small" @click="openAdd">新增角色</Button>
		</div>
		<div class="role-body">
			<table class="h-table" style="width:100%;">
				<tr>
					<th style="width:160px;">角色名称</th>
					<th style="width:120px;">编码</th>
					<th>功能权限</th>
					<th style="width:100px;">数据范围</th>
					<th style="width:90px;">类型</th>
					<th style="width:110px;">操作</th>
				</tr>
				<tr v-for="r in roles" :key="r.id">
					<td>{{r.name}}</td>
					<td>{{r.code}}</td>
					<td>
						<span v-if="parsePerms(r.permissions).length === 0" class="dark4-color">无任何操作权限（仅查看）</span>
						<span v-else>{{parsePerms(r.permissions).length}} 项权限：{{permText(r.permissions)}}</span>
					</td>
					<td>{{r.dataScope === 1 ? '仅本人数据' : '全部数据'}}</td>
					<td>
						<span v-if="r.builtIn === 1" class="blue-color">内置</span>
						<span v-else>自定义</span>
					</td>
					<td>
						<template v-if="r.builtIn !== 1">
							<span class="text-hover" @click="openEdit(r)">编辑</span>
							<span class="text-hover red-color margin-left" @click="del(r)">删除</span>
						</template>
						<span v-else class="dark4-color">—</span>
					</td>
				</tr>
			</table>
		</div>

		<Modal v-model="editModal" :width="900">
			<div slot="header">{{editForm.id ? '编辑角色' : '新增角色'}}</div>
			<div class="edit-form">
				<div class="form-row">
					<div class="label">角色名称</div>
					<div class="control"><input type="text" v-model="editForm.name" placeholder="如：审核会计"></div>
				</div>
				<div class="form-row">
					<div class="label">数据范围</div>
					<div class="control">
						<label><input type="radio" v-model="editForm.dataScope" :value="0">全部数据</label>
						<label><input type="radio" v-model="editForm.dataScope" :value="1">仅本人数据（只能看到自己填制的凭证）</label>
					</div>
				</div>
				<div class="form-row align-top">
					<div class="label">功能权限</div>
					<div class="control perm-matrix">
						<div v-for="m in tree" :key="m.code" class="mx-module">
							<div class="mx-module-head">
								<label>
									<input type="checkbox" :checked="moduleChecked(m)" @change="toggleModule(m, $event)">{{m.name}}
								</label>
								<span class="mx-all" @click="moduleChecked(m) ? clearModule(m) : selectModule(m)">全选</span>
							</div>
							<div v-for="f in m.funcs" :key="f.code" class="mx-func-row">
								<span class="mx-func-name">
									<input type="checkbox" :checked="funcChecked(m, f)" @change="toggleFunc(m, f, $event)">{{f.name}}
								</span>
								<span class="mx-ops">
									<label v-for="o in f.ops" :key="o.code">
										<input type="checkbox" :value="keyOf(m, f, o)" v-model="checkedPerms">{{o.name}}
									</label>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<Button color="green" @click="save">保存</Button>
				<Button color="primary" @click="editModal=false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {TREE} from '../../js/common/permissionTree';

	export default {
		name: 'RoleManage',
		data() {
			return {
				roles: [],
				editModal: false,
				editForm: {
					id: null,
					name: '',
					dataScope: 0
				},
				checkedPerms: [],
				tree: TREE,
				pointNames: {}
			};
		},
		created() {
			TREE.forEach(m => m.funcs.forEach(f => f.ops.forEach(o => {
				this.pointNames[`${m.code}.${f.code}.${o.code}`] = `${f.name}-${o.name}`;
			})));
		},
		methods: {
			parsePerms(json) {
				try {
					return json ? JSON.parse(json) : [];
				} catch (e) {
					return [];
				}
			},
			permText(json) {
				return this.parsePerms(json).map(k => this.pointNames[k] || k).join('、');
			},
			load() {
				this.$api.setting.role.list().then(({data}) => {
					this.roles = data || [];
				});
			},
			openAdd() {
				this.editForm = {id: null, name: '', dataScope: 0};
				this.checkedPerms = [];
				this.editModal = true;
			},
			openEdit(r) {
				this.editForm = {id: r.id, name: r.name, dataScope: r.dataScope};
				this.checkedPerms = this.parsePerms(r.permissions);
				this.editModal = true;
			},
			keyOf(m, f, o) {
				return `${m.code}.${f.code}.${o.code}`;
			},
			funcKeys(m, f) {
				return f.ops.map(o => this.keyOf(m, f, o));
			},
			moduleKeys(m) {
				let keys = [];
				m.funcs.forEach(f => {
					keys = keys.concat(this.funcKeys(m, f));
				});
				return keys;
			},
			funcChecked(m, f) {
				return this.funcKeys(m, f).every(k => this.checkedPerms.indexOf(k) > -1);
			},
			moduleChecked(m) {
				return this.moduleKeys(m).every(k => this.checkedPerms.indexOf(k) > -1);
			},
			toggleFunc(m, f, e) {
				if (e.target.checked) {
					this.selectKeys(this.funcKeys(m, f));
				} else {
					this.removeKeys(this.funcKeys(m, f));
				}
			},
			toggleModule(m, e) {
				if (e.target.checked) {
					this.selectKeys(this.moduleKeys(m));
				} else {
					this.removeKeys(this.moduleKeys(m));
				}
			},
			selectModule(m) {
				this.selectKeys(this.moduleKeys(m));
			},
			clearModule(m) {
				this.removeKeys(this.moduleKeys(m));
			},
			selectKeys(keys) {
				keys.forEach(k => {
					if (this.checkedPerms.indexOf(k) === -1) {
						this.checkedPerms.push(k);
					}
				});
			},
			removeKeys(keys) {
				this.checkedPerms = this.checkedPerms.filter(k => keys.indexOf(k) === -1);
			},
			save() {
				if (!this.editForm.name || !this.editForm.name.trim()) {
					this.$Message('请输入角色名称');
					return;
				}
				let params = {
					id: this.editForm.id,
					name: this.editForm.name.trim(),
					dataScope: this.editForm.dataScope,
					permissions: JSON.stringify(this.checkedPerms)
				};
				this.$api.setting.role.save(params).then(() => {
					this.$Message('保存成功');
					this.editModal = false;
					this.load();
				});
			},
			del(r) {
				this.$Confirm(`确认删除角色「${r.name}」?该角色下的成员将自动回落到仅查看角色。`).then(() => {
					this.$api.setting.role.delete(r.id).then(() => {
						this.$Message('删除成功');
						this.load();
					});
				});
			}
		},
		mounted() {
			this.load();
		}
	};
</script>

<style lang='less' scoped>
	.role-body {
		padding: 15px 20px;
	}

	.edit-form {
		.form-row {
			display: flex;
			padding: 8px 0;

			&.align-top {
				align-items: flex-start;
			}

			.label {
				width: 80px;
				flex-shrink: 0;
				padding-top: 4px;
			}

			.control {
				flex: 1;

				input[type=text] {
					width: 260px;
				}

				label {
					margin-right: 18px;
				}
			}

			.perm-matrix {
				border: 1px solid #e8e8e8;
				border-radius: 4px;
				max-height: 460px;
				overflow-y: auto;

				.mx-module {
					border-bottom: 1px solid #f0f0f0;

					&:last-child {
						border-bottom: none;
					}
				}

				.mx-module-head {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 8px 12px;
					background: #fafafa;

					label {
						font-weight: bold;
						margin: 0;
					}

					.mx-all {
						color: #2d8cf0;
						font-size: 12px;
						cursor: pointer;
						font-weight: normal;
					}
				}

				.mx-func-row {
					display: flex;
					align-items: center;
					padding: 6px 12px 6px 20px;

					.mx-func-name {
						width: 170px;
						flex-shrink: 0;

						input {
							margin-right: 6px;
						}
					}

					.mx-ops {
						flex: 1;

						label {
							display: inline-block;
							min-width: 78px;
							margin: 0 10px 0 0;
							font-weight: normal;
						}
					}
				}
			}
		}
	}
</style>
